import { render, staticRenderFns } from "./CoordinatorUserIcon.vue?vue&type=template&id=57530ba2&scoped=true&"
import script from "./CoordinatorUserIcon.vue?vue&type=script&lang=js&"
export * from "./CoordinatorUserIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57530ba2",
  null
  
)

export default component.exports